export type Gid = `gid://shopify/${string}/${number}`;
export function getNumericIdFromGid(gid: Gid): `${number}` {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-unsafe-type-assertion
  return gid.split("/").pop()! as `${number}`; // still returned as a string - don't use for math
}

const gidRegex = /^gid:\/\/shopify\/(\w+)\/(\d+)$/;

function isGid(id: string): id is Gid {
  return gidRegex.test(id);
}

/**
 * Best effort that handles cases where we erroneously stored the gid instead of the id.
 */
export function parseNumericIdFromShopifyId(id: string): `${number}` {
  if (isGid(id)) {
    return getNumericIdFromGid(id);
  } else {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    return id as `${number}`;
  }
}

export enum ShopifyIdType {
  Article = "Article",
  Blog = "Blog",
  Collection = "Collection",
  Customer = "Customer",
  DeliveryCarrierService = "DeliveryCarrierService",
  DeliveryLocationGroup = "DeliveryLocationGroup",
  DeliveryProfile = "DeliveryProfile",
  DeliveryZone = "DeliveryZone",
  DraftOrder = "DraftOrder",
  DraftOrderLineItem = "DraftOrderLineItem",
  Dispute = "ShopifyPaymentsDispute",
  DisputeEvidence = "ShopifyPaymentsDisputeEvidence",
  Duty = "Duty",
  EmailTemplate = "EmailTemplate",
  Fulfillment = "Fulfillment",
  FulfillmentEvent = "FulfillmentEvent",
  FulfillmentService = "FulfillmentService",
  InventoryItem = "InventoryItem",
  InventoryLevel = "InventoryLevel",
  LineItem = "LineItem",
  Location = "Location",
  MarketingEvent = "MarketingEvent",
  MediaImage = "MediaImage",
  Video = "Video",
  Model3D = "Model3D",
  ExternalVideo = "ExternalVideo",
  Metafield = "Metafield",
  Order = "Order",
  OrderTransaction = "OrderTransaction",
  Page = "Page",
  Product = "Product",
  ProductImage = "ProductImage",
  ProductVariant = "ProductVariant",
  Refund = "Refund",
  Shop = "Shop",
  StaffMember = "StaffMember",
  Theme = "Theme",
  GiftCard = "GiftCard",
  SellingPlan = "SellingPlan",
  CalculatedOrder = "CalculatedOrder",
  CalculatedLineItem = "CalculatedLineItem",
  MetafieldDefinition = "MetafieldDefinition",
  Publication = "Publication",
  MarketCatalog = "MarketCatalog",
  AppCatalog = "AppCatalog",
  CompanyLocationCatalog = "CompanyLocationCatalog",
}

export function convertShopifyIdToGid(
  gidOrNumericId: string,
  type: ShopifyIdType,
): Gid {
  if (isGid(gidOrNumericId)) {
    return gidOrNumericId;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return `gid://shopify/${type}/${gidOrNumericId}` as Gid;
}
